import { useEffect, useState } from 'react';
import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { queryAnalyticsCounts } from '../../api';

ChartJS.register(CategoryScale, Filler, Legend, LineElement, LinearScale, PointElement, Tooltip);
ChartJS.defaults.font.family = "'Luckiest Guy', sans-serif";

const DAY_IN_MS = 24 * 60 * 60 * 1000;

function formatDate(date) {
  return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' }).format(date);
}

export default function PageVisitsCharts({ surface = 'home', action = 'page_view', category = 'page_view' }) {
  const [points, setPoints] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const end = new Date();
    const start = new Date(end.getTime() - 7 * DAY_IN_MS);

    async function loadPageVisits() {
      try {
        const response = await queryAnalyticsCounts({
          environment: 'prod',
          surface,
          action,
          category,
          from: start.toISOString(),
          to: end.toISOString()
        });

        if (!cancelled) {
          setPoints(response.data.buckets.map(({ bucketStart, count }) => ({ date: formatDate(new Date(bucketStart)), visits: count })));
        }
      } catch (loadError) {
        console.error('Unable to load production page visits:', loadError);
        if (!cancelled) setError(true);
      }
    }

    loadPageVisits();
    return () => {
      cancelled = true;
    };
  }, [action, category, surface]);

  if (error) return <p className="metrics-status">Page visit data could not be loaded.</p>;
  if (!points.length) return <p className="metrics-status">Loading page visits...</p>;

  const labels = points.map(({ date }) => date);
  const chartJsData = {
    labels,
    datasets: [{ data: points.map(({ visits }) => visits), borderColor: '#178a37', backgroundColor: 'rgba(23, 138, 55, 0.14)', fill: true, tension: 0.25 }]
  };
  const chartJsOptions = {
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { x: { grid: { display: false } }, y: { beginAtZero: true, title: { display: false }, ticks: { precision: 0, stepSize: 1 } } }
  };

  return (
    <div className="page-visits-charts">
      <div className="metrics-chart"><Line data={chartJsData} options={chartJsOptions} /></div>
    </div>
  );
}